import type { clientTypes } from '@bedc/client/types';

import bedcHeader from '../assets/bedc/logo_header.png';
import bedcLogin from '../assets/bedc/logo_login.png';
import cartersHeader from '../assets/carters/logo_header.png';
import cartersLogin from '../assets/carters/logo_login.png';

import { resolveBrandId } from './brandUtils';

const logos = {
	bedc: { headerLogo: bedcHeader, loginLogo: bedcLogin },
	carters: { headerLogo: cartersHeader, loginLogo: cartersLogin },
} satisfies Record<clientTypes.brand.Id, { headerLogo: string; loginLogo: string }>;

/**
 * Get the bundled application logos for a brand.
 *
 * @param id The selected brand ID.
 * @returns The header and login logo URLs.
 */
export function getBrandLogos(id?: clientTypes.brand.Id) {
	return logos[resolveBrandId(id)];
}
